import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

//Import Action
import { removeFromCart } from '../../../action/cart';

//Import Utils
import { getCartTotal, getQtyTotal } from '../../../utils';

function CartMenu(props) {
  const location = useLocation();
  const { btnClass = "btn-primary", cartItems, removeFromCart } = props;
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(false);
  }, [location.pathname]);

  return (
    <div className="dropdown cart-dropdown">
      <Link className="dropdown-toggle" to="/koszyk" onClick={(location.pathname !== '/koszyk' && location.pathname !== '/koszyk/dostawa-i-platnosc' && location.pathname !== '/koszyk/dostawa-i-platnosc/gotowe') ? (e) => setShow(!show) : ''} role="button" aria-haspopup="true" aria-expanded="false" data-display="static">
        {/* <i className="minicart-icon"></i> */}
        <i className="icon-cart-1"></i>
        <span className="cart-count">{getQtyTotal(cartItems)}</span>
        <span className="cart">Koszyk</span>
      </Link>

      <div className={`dropdown-menu ${show ? 'show' : ''}`}>
        <div className="dropdownmenu-wrapper">
          <div className="dropdown-cart-header">
            <span>{getQtyTotal(cartItems)} {getQtyTotal(cartItems) === 0 ? "Produktów" : getQtyTotal(cartItems) === 1 ? "Produkt" : getQtyTotal(cartItems) <= 4 ? "Produkty" : getQtyTotal(cartItems) > 4 ? "Produktów" : ""}</span>
            <Link to={`${process.env.PUBLIC_URL}/koszyk`} className="float-right">Zobacz koszyk</Link>
          </div>

          <div className="dropdown-cart-products">
            {
              cartItems.map((item, index) => (
                <div className="product" key={"Product" + index}>
                  <div className="product-details">
                    <h2 className="product-title">
                      <Link to={`${process.env.PUBLIC_URL}/produkty/${item.product ? item.product.category.category_slug : item.category.category_slug}/${item.product ? item.product_variant_slug : item.product_slug}`}>{item.product ? item.product_variant_name : item.product_name}</Link>
                    </h2>
                    <span className="cart-product-info">
                      <span className="cart-product-qty">{item.qty} {item.product ? item.product.package.package_value : item.package.package_value}</span>
                    </span>
                  </div>
                  {
                    item.product ?
                      item.product.images.slice(0, 1).map(image => (
                        <figure className="product-image-container" key={image.product_image_id}>
                          <Link to={`${process.env.PUBLIC_URL}/produkty/${item.product.category.category_slug}/${item.product_variant_slug}`} className="product-image">
                            <img src={`https://d22u7e6casvzfe.cloudfront.net/uploads/products/320x320/${image.product_image}`} alt={!!image.product_image_alt ? image.product_image_alt : item.product_variant_name} />
                          </Link>
                          <Link to="#" className="btn-remove icon-cancel" title="Usuń produkt" onClick={(e) => { e.preventDefault(); removeFromCart(item); }}></Link>
                        </figure>
                      ))
                      :
                      item.images.slice(0, 1).map(image => (
                        <figure className="product-image-container" key={image.product_image_id}>
                          <Link to={`${process.env.PUBLIC_URL}/produkty/${item.category.category_slug}/${item.product_slug}`} className="product-image">
                            <img src={`https://d22u7e6casvzfe.cloudfront.net/uploads/products/320x320/${image.product_image}`} alt={!!image.product_image_alt ? image.product_image_alt : item.product_name} />
                          </Link>
                          <Link to="#" className="btn-remove icon-cancel" title="Usuń produkt" onClick={(e) => { e.preventDefault(); removeFromCart(item); }}></Link>
                        </figure>
                      ))
                  }
                </div>
              ))
            }
          </div>
          <div className="dropdown-cart-total">
            <span>Koszt</span>
            <span className="cart-total-price float-right">{getCartTotal(cartItems).toFixed(2)} zł</span>
          </div>
          <div className="dropdown-cart-action">
            <Link to={`${process.env.PUBLIC_URL}/koszyk`} className={"btn btn-block " + btnClass}>Do kasy</Link>
          </div>
        </div>
      </div>
    </div>
  );

}


function mapStateToProps(state) {
  return {
    cartItems: state.cartList.cart ? state.cartList.cart : []
  };
}

export default connect(mapStateToProps, { removeFromCart })(CartMenu);